module.exports = __webpack_public_path__ + "static/img/logo.0338ca2a.png";